import { isDrawerPaneVisible } from "owa-drawer";
import closeHeaderPane from "./closeHeaderPane";
import openHeaderPane from "./openHeaderPane";

export default function toggleHeaderPane(paneId: string): void {
    if (isDrawerPaneVisible(paneId)) {
        closeHeaderPane(paneId);
    }
    else {
        openHeaderPane(paneId);
    }
}
